import { render, staticRenderFns } from "./FormLinks.vue?vue&type=template&id=221ea080&scoped=true&"
import script from "./FormLinks.vue?vue&type=script&lang=js&"
export * from "./FormLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221ea080",
  null
  
)

export default component.exports